(function(){
  var timer=null, busy=false, last=-1;
  function isTechnical(item){return item&&item.properties&&item.properties._tk_technical==='1';}
  function visibleCount(cart){return (cart.items||[]).reduce(function(n,item){return n+(isTechnical(item)?0:(item.quantity||0));},0);}
  function fixTotalLabels(){
    document.querySelectorAll('.totals__total').forEach(function(el){
      if(el.textContent.trim()!=='Gesamtpreis')el.textContent='Gesamtpreis';
    });
  }
  function render(count){
    var link=document.getElementById('cart-icon-bubble');
    if(!link)return;
    var bubble=link.querySelector('.cart-count-bubble');
    if(count<=0){if(bubble)bubble.remove();return;}
    if(!bubble){bubble=document.createElement('div');bubble.className='cart-count-bubble';bubble.innerHTML='<span aria-hidden="true"></span><span class="visually-hidden"></span>';link.appendChild(bubble);}
    var visual=bubble.querySelector('[aria-hidden="true"]');
    var hidden=bubble.querySelector('.visually-hidden');
    if(visual)visual.textContent=count<100?String(count):'';
    if(hidden)hidden.textContent=count===1?'1 Artikel im Warenkorb':count+' Artikel im Warenkorb';
  }
  function sync(){
    if(busy)return;
    busy=true;
    fetch('/cart.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){var count=visibleCount(cart);last=count;render(count);fixTotalLabels();})
      .catch(function(){})
      .finally(function(){busy=false;});
  }
  function queue(){clearTimeout(timer);timer=setTimeout(sync,120);}
  function start(){fixTotalLabels();sync();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('cart:refresh',queue);
  var observer=new MutationObserver(function(mutations){
    fixTotalLabels();
    var relevant=mutations.some(function(m){
      return Array.from(m.addedNodes||[]).concat(Array.from(m.removedNodes||[])).some(function(n){return n.nodeType===1&&(n.id==='cart-icon-bubble'||(n.querySelector&&n.querySelector('#cart-icon-bubble')));});
    });
    if(relevant)queue();
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();